<template>
    <div class="modal-rapport modal-card">
        <div class="modal-card-head">
            <h2 class="modal-card-title">Rapport du calculateur</h2>
            <a class="close-button" @click="$emit('close')">
                <span class="icon-close"></span>
            </a>
        </div>
        <div class="modal-card-body">
            <p>Formulaire d'envoi du rapport du calculateur de capacité</p>
            <form @submit.prevent="submit">
                <div class="columns">
                    <b-field class="column is-full-mobile is-half-tablet" :label="$t('select_date')">
                        <b-datepicker
                            v-model="date"
                            placeholder="Click to select..."
                            icon="calendar-today"
                            :icon-right="date ? 'close-circle' : ''"
                            icon-right-clickable
                            @icon-right-click="clearDate"
                            trap-focus
                            required
                            rounded>
                        </b-datepicker>
                    </b-field>
                    <b-field class="column is-full-mobile is-half-tablet" :label="$t('author')">
                        <b-input v-model="author" rounded required></b-input>
                    </b-field>
                </div>
                <div class="columns">
                    <b-field class="column is-full-mobile is-half-tablet" :label="$t('dealer')">
                        <b-input v-model="dealer" rounded required></b-input>
                    </b-field>
                    <b-field class="column is-full-mobile is-half-tablet" :label="$t('recipient')">
                        <b-input v-model="recipient" rounded required></b-input>
                    </b-field>
                </div>
                <p class="warning">Warning : the results given are the result of thearetical calculations. They must be validated by a plateform testing.</p>
                <b-field :label="$t('comment')">
                    <b-input v-model="comment" rounded maxlength="600" type="textarea"></b-input>
                </b-field>
                <p>Remaining at your disposal for further information, Regards.</p>
                <b-field>
                    <b-checkbox v-model="checked" required>J'accepte les conditions de ... etc</b-checkbox>
                </b-field>
            </form>
        </div>
        <div class="modal-card-foot">
            <b-button rounded class="is-primary is-background-color-red" icon-left="envelope">{{ $t('send_by_mail') }}</b-button>
            <b-button rounded class="is-primary is-bordered is-background-color-carbon" icon-left="download">{{ $t('download_rapport') }}</b-button>
            <b-button rounded class="is-bordered is-background-color-white" icon-left="print">{{ $t('print') }}</b-button>
        </div>
    </div>
</template>

<script>
export default {
    name: "RapportModal",
    data() {
        return {
            date: null,
            author: null,
            dealer: null,
            recipient: null,
            comment: null,
            checked: false,
        }
    },
    methods: {
        submit() {

        },
        clearDate () {
            this.date = null
        }
    }
}
</script>

<style lang="scss">
    .modal-card {
        max-width: 960px;
        width: calc(100% - 20px);
        margin: 0 10px!important;

        @media #{$mq_phone_min} {
            width: calc(100% - 40px);
            margin: 0 20px!important;
        }

        &-head {
            position: relative;

            .close-button {
                position: absolute;
                right: 12px;
                top: 12px;
                font-size: 1.2rem;
                font-weight: lighter;
            }
        }

        &-body {
            p{
                font-style: italic;

                &.warning {
                    font-style: normal;
                    text-decoration: underline;
                }
            }

            .column {
                padding-top: 0;
                padding-bottom: 0;
            }

            .field {
                margin-top: 12px;
            }
        }

        &-foot {
            justify-content: flex-end;

            @media #{$mq_phone} {
                justify-content: center;
                flex-wrap: wrap;

                .button {
                    margin-bottom: 8px;
                }
            }

            .button {
                margin-left: 10px;

                &.is-bordered {
                    border: solid 1px $brand_red;
                }
            }
        }
    }
</style>
